import React, { useState } from "react";
import LockerMapMobile from "./LockerMapMobile";
import { useHistory } from "react-router-dom";
import { GestTokenGenerate, GetLockerDetailsNearToUser } from "../api/api";
import CircularProgressLoader from "./CircularProgressLoader";
import ShowToast from "./ToastComponent";
import { TOAST_ERROR } from "../assets/constants/Constants";
import { storeSecureItemInSpecifiedStorage } from "../lib/BrowserStorageAccessMiddleware";
import { LOCAL_STORAGE } from "../assets/constants/BrowserStorageKeys";
import { getPathForNextPage } from "../lib/Utils";
import { HOME, MAP } from "../assets/constants/PageList";

const LockerMapPreview = () => {
  const [isLocating, setIsLocating] = useState(false);
  const [locationError, setLocationError] = useState(null);
  const [showLoader, setShowLoader] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("");
  const [lockersData, setLockersData] = useState([]);

  const history = useHistory();

  // Default location (Pune)
  const defaultLocation = {
    lat: 18.5292,
    lng: 73.8746,
  };

  const handleFindLockers = async () => {
    setIsLocating(true);
    setLocationError(null);
    setShowLoader(true);
    setLoadingMessage("Getting your location...");

    if (!navigator.geolocation) {
      setLocationError("Geolocation is not supported in this browser.");
      setIsLocating(false);
      setShowLoader(false);
      ShowToast("location did not permit please allow it", TOAST_ERROR);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        try {
          const userLocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };

          console.log("userLocation", userLocation);

          setLoadingMessage("please wait.....");
          
          // Generate guest token
          const responseGenerateToken = await GestTokenGenerate();
          storeSecureItemInSpecifiedStorage(LOCAL_STORAGE, 'guess_token', responseGenerateToken?.data?.token);
          console.log("responseGenerateToken:", responseGenerateToken);
          
          if (responseGenerateToken.status === 'success') {
            setShowLoader(true);
            const data = {
              "distance": 1000000,
              "location": {
                lat: userLocation.lat,
                lng: userLocation.lng
              },
              token: responseGenerateToken?.data?.token
            };
            
            setLoadingMessage("Getting lockers near you...");
            
            const response = await GetLockerDetailsNearToUser(data);
            console.log("response:", response);
            
            if (response?.data?.status === 'success') {
              const apiData = response?.data?.data;
              setLockersData(apiData);
              
              setLoadingMessage("Opening locker map...");

              // Small delay for smoother UX
              setTimeout(() => {
                setShowLoader(false);
                
                // Navigate to map with data
                history.push({
                  // pathname: getPathForNextPage(HOME, MAP),
                  pathname: "/map",
                  state: {
                    center: userLocation,
                    useUserLocation: true,
                    lockersData: apiData,
                    timestamp: Date.now() // Add timestamp to force update
                  },
                });
              }, 500);
            } else {
              setShowLoader(false);
              ShowToast("Failed to fetch lockers data", TOAST_ERROR);
            }
          } else {
            setShowLoader(false);
            ShowToast("User are not able to authemitcted as gest user", TOAST_ERROR);
          }
        } catch (err) {
          console.log("Token generation error:", err);
          setLocationError("Something went wrong while generating token.");
          setShowLoader(false);
        } finally {
          setIsLocating(false);
        }
      },
      (error) => {
        console.log("Location error:", error);
        setLocationError("Location permission denied. Please allow location access.");
        setIsLocating(false);
        setShowLoader(false);

        setTimeout(() => {
          setLocationError(null);
        }, 5000);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      }
    );
  };

  return (
      <div className="locker-map-preview"  onClick={handleFindLockers}>
        <div className="preview-map-container">
          <div className="mini-map-wrapper">
            <LockerMapMobile
              isPreview={true}
              initialLocation={defaultLocation}
            />
          </div>
        </div>
        <div
          className={`find-lockers-btn-container ${
            isLocating ? "locating" : ""
          }`}
          onClick={handleFindLockers}
        >
          <h1 className="find-locker-heading">
            {isLocating
              ? "Getting your location..."
              : "Find lockers near me"}
          </h1>
        </div>
        {showLoader && (
        <CircularProgressLoader message={loadingMessage} />
      )}
      </div>

      
  );
};

export default LockerMapPreview;